import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import MarketShareTrendChart from './MarketShareTrendChart';
import CompetitorRadarChart from './CompetitorRadarChart';
import PricePositioningScatter from './PricePositioningScatter';
import CompetitorComparisonTable from './CompetitorComparisonTable';
const MarketShareAnalysisDashboard: React.FC = () => {
  const kpis = [{
    title: 'Market Share %',
    value: '12.8%',
    change: '+0.7%',
    isPositive: true,
    subtitle: 'Overall India market'
  }, {
    title: 'Competitor Gap Index',
    value: '85',
    change: '+3 pts',
    isPositive: true,
    subtitle: 'vs market leader'
  }, {
    title: 'Price Competitiveness %',
    value: '92%',
    change: '+2%',
    isPositive: true,
    subtitle: 'Price positioning'
  }];
  return <div data-id="element-7794">
      <DescriptionPanel title="Market Share & Competitor Benchmarking" description="Strategic analysis of market position, competitive landscape, and pricing dynamics across automotive segments. Track market share evolution, competitor strengths, and price positioning to identify growth opportunities and defend market position." insights={['Overall market share at 12.8% - gained 0.7% in last quarter', 'Strongest position in 2-Wheeler segment at 15.2% share', 'Competitor Gap Index improved to 85 - closing gap with market leader', 'Price competitiveness at 92% - optimal balance of value and margin']} data-id="element-7795" />
      {/* KPI Tiles */}
      <div className="mb-8" data-id="element-7796">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-7797">
          Market Position Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-7798">
          {kpis.map((kpi, index) => <Card key={index} className="p-6 bg-gradient-to-br from-white to-gray-50" data-id="element-7799">
              <div className="flex flex-col h-full" data-id="element-7800">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" data-id="element-7801">
                  {kpi.title}
                </div>
                <div className="text-xs text-gray-400 mb-3" data-id="element-7802">{kpi.subtitle}</div>
                <div className="text-4xl font-bold text-gray-900 mb-3" data-id="element-7803">
                  {kpi.value}
                </div>
                <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-7804">
                  {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-7805" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-7806" />}
                  {kpi.change} vs last quarter
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* Market Share Trend - Full Width */}
      <MarketShareTrendChart data-id="element-7807" />
      {/* Main Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-7808">
        <CompetitorRadarChart data-id="element-7809" />
        <PricePositioningScatter data-id="element-7810" />
      </div>
      {/* Competitor Comparison Table */}
      <CompetitorComparisonTable data-id="element-7811" />
    </div>;
};
export default MarketShareAnalysisDashboard;